import './App.css';
import HomeScreen from './Home';

function App() {
  return (
    <div className="App">
      <HomeScreen/>
    </div>
  );
}

export default App;
